import { createContext } from 'react'


export const ProvideContext = createContext({})


